/**
 * UniApp WebView Bridge - 用于检测 WebView 环境并与原生 App 通信
 * 在 UniApp 套壳 App 中，web-view 内的网页通过此模块调用原生能力（如相机、相册）
 */

let isUniAppWebView = false;
let bridgeReady = false;

function detectUniAppEnv() {
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.includes('uni-app') ||
    ua.includes('html5plus') ||
    typeof window.uni !== 'undefined' ||
    typeof window.plus !== 'undefined'
  );
}

isUniAppWebView = detectUniAppEnv();

export function getIsUniAppWebView() {
  return isUniAppWebView;
}

export function getIsMobile() {
  const ua = navigator.userAgent.toLowerCase();
  return /android|iphone|ipad|ipod|mobile/i.test(ua);
}

export function initUniBridge() {
  if (!getIsMobile()) return Promise.resolve(false);

  return new Promise((resolve) => {
    if (typeof window.uni !== 'undefined') {
      bridgeReady = true;
      isUniAppWebView = true;
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@niconi/uni-webview-js@0.0.4/index.js';
    script.onload = () => {
      if (typeof window.uni !== 'undefined') {
        bridgeReady = true;
        isUniAppWebView = true;
      }
      resolve(bridgeReady);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.head.appendChild(script);
  });
}

/**
 * 通过 UniApp 原生桥接选择图片（相册+相机）
 * 如果不在 UniApp 环境则返回 null，由调用方使用浏览器方式处理
 */
export function uniChooseImage(options = {}) {
  if (!isUniAppWebView || !window.uni) {
    return null;
  }

  window.uni.postMessage({
    data: {
      action: 'chooseImage',
      sourceType: options.sourceType || ['album', 'camera'],
      count: options.count || 1,
      sizeType: options.sizeType || ['compressed'],
    }
  });

  return new Promise((resolve, reject) => {
    const handler = (event) => {
      const detail = event.detail;
      if (detail && detail.action === 'chooseImageResult') {
        window.removeEventListener('uniAppMessage', handler);
        if (detail.data && detail.data.success) {
          resolve(detail.data);
        } else {
          reject(new Error(detail.data ? detail.data.error : 'choose image failed'));
        }
      }
    };
    window.addEventListener('uniAppMessage', handler);

    setTimeout(() => {
      window.removeEventListener('uniAppMessage', handler);
      reject(new Error('timeout'));
    }, 60000);
  });
}

/**
 * 在 App 内通过系统浏览器打开 URL（支持相册等原生能力）
 * 优先使用 plus.runtime.openURL（HTML5+ 环境）
 * UniApp 环境用 postMessage 通知原生端打开浏览器
 * 兜底使用 window.open
 */
export function openInBrowser(url) {
  if (!url) return;
  if (window.plus && window.plus.runtime) {
    window.plus.runtime.openURL(url);
  } else if (isUniAppWebView && window.uni) {
    window.uni.postMessage({
      data: {
        action: 'openBrowser',
        url: url,
      }
    });
  } else {
    window.open(url, '_system');
  }
}

/**
 * 移动端通过 input[type=file] 选择图片（支持相机+相册）
 * 用于非 UniApp 环境的 H5 浏览器
 */
export function browserChooseImage(options = {}) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    if (options.multiple) {
      input.multiple = true;
    }
    if (options.capture) {
      input.capture = options.capture;
    }

    input.onchange = (e) => {
      const files = Array.from(e.target.files || []);
      if (files.length > 0) {
        resolve(files);
      } else {
        reject(new Error('no file selected'));
      }
      input.value = '';
    };

    input.click();
  });
}
